var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
var StyledHamburgerLine = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 2.5px;\n  background-color: ", ";\n  margin: 8px 0;\n"], ["\n  width: 100%;\n  height: 2.5px;\n  background-color: ", ";\n  margin: 8px 0;\n"])), function (props) { return props.color; });
var StyledHamburger = styled.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 35px;\n  display: block;\n  cursor: pointer;\n"], ["\n  width: 35px;\n  display: block;\n  cursor: pointer;\n"])));
function Hamburger(_a) {
    var props = __rest(_a, []);
    return (React.createElement(StyledHamburger, __assign({}, props),
        React.createElement(StyledHamburgerLine, { color: props.color }),
        React.createElement(StyledHamburgerLine, { color: props.color })));
}
export default Hamburger;
var templateObject_1, templateObject_2;
